// Demo page: NextAdmin / (home) dashboard (DashboardPage) with the /ui-elements/tabs underline tabs.
import { DashboardPage } from '../../components/page/index.js';
import { Card } from '../../components/ui/Card.js';
import { markdownOverrides } from '../../components/ui/HelpPanel.js';
import { SafeMarkdown } from '../../components/ui/SafeMarkdown.js';
import { Tabs } from '../../components/ui/Tabs.js';
import { useTabParam } from '../../hooks/useTabParam.js';
import { ArchitectureGraph } from './ArchitectureGraph.js';
import { PAGE_HELP } from '../../help/index.js';
import { VIEWS } from './system-overview-data.js';

const VIEW_IDS = VIEWS.map((view) => view.id);

export function SystemOverviewPage() {
  const [activeView, setActiveView] = useTabParam(VIEW_IDS, VIEW_IDS[0]);
  const currentView = VIEWS.find((view) => view.id === activeView) ?? VIEWS[0];
  const hasGraph = currentView.nodes.length > 0;

  return (
    <DashboardPage
      title="System architecture"
      helpContent={PAGE_HELP['system-overview']}
      subtitle="Architecture diagrams for the product runtime, entity flows, and operator surfaces."
    >
      <Tabs
        tabs={VIEWS.map((view) => ({ id: view.id, label: view.title }))}
        activeTab={currentView.id}
        onChange={setActiveView}
        aria-label="Architecture views"
      />
      <p className="text-sm leading-relaxed text-text-tertiary">{currentView.description}</p>
      {hasGraph && (
        <ArchitectureGraph
          nodes={currentView.nodes}
          edges={currentView.edges}
          lanes={currentView.lanes}
          legend={currentView.legend}
        />
      )}
      {currentView.markdown && (
        <Card>
          <SafeMarkdown overrides={markdownOverrides}>{currentView.markdown}</SafeMarkdown>
        </Card>
      )}
    </DashboardPage>
  );
}
